import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'
import useAppEvents from '../../../hooks/events/events'
import { AppEventsEnum } from '../../../hooks/events/events.types'

const PageView = () => {
  const location = useLocation()
  const { triggerEvent } = useAppEvents()

  useEffect(() => {
    console.log('PageView triggered for:', location.pathname, location.search)
    triggerEvent(AppEventsEnum.PAGE_VIEW, { location, title: document.title })
  }, [location.pathname, location.search])

  return null
}

export default PageView
